import { STATUS_PROCESS_OBV } from '../../constants/status';

export const INITIAL_STATE = {
  isLoading: false,
  statusProcess: STATUS_PROCESS_OBV.NONE,
  isVerification: false,
  isBackMerchant: false,
  hidePlaidFooter: true,
  obvInfo: {},
  error: null,
};
